import { Constants } from "config/constants";

const CrCashPayableOnShares = () => {
  return (
    <table className="divide-y divide-gray-300 border-separate border-spacing-1 table-auto">
      <thead className="text-xs">
        <tr>
          <th
            colspan="2"
            scope="col"
            className="font-semibold text-gray-900 bg-gray-100 h-10"
          >
            CASH PAID ON SHARES
          </th>
          <th
            colspan="2"
            scope="col"
            className="font-semibold text-gray-900 bg-gray-100 h-10"
          >
            Cr.
          </th>
        </tr>
        <tr style={{ height: "110px" }}>
          <th
            scope="col"
            rowspan="5"
            className="font-semibold text-gray-900 bg-gray-100"
          >
            Date When Due
          </th>
          <th
            scope="col"
            rowspan="5"
            className="font-semibold text-gray-900 bg-gray-100"
          >
            Date of Payment
          </th>
          <th
            scope="col"
            rowspan="5"
            className="font-semibold text-gray-900 bg-gray-100"
          >
            Cash Book Folio
          </th>
          <th
            scope="col"
            rowspan="5"
            className="font-semibold text-gray-900 bg-gray-100"
          >
            Total Amount
          </th>
        </tr>
        <tr style={{ height: "42px" }}></tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {Array.from(new Array(Constants.REGISTERS.LEDGER_ROWS)).map(
          (_, index) => (
            <tr key={index} className="text-xs">
              <td
                className="p-1 text-gray-600 bg-gray-100"
                style={{ height: "26px" }}
              ></td>
              <td
                className="p-1 text-gray-600 bg-gray-100"
                style={{ height: "26px" }}
              ></td>
              <td
                className="p-1 text-gray-600 bg-gray-100"
                style={{ height: "26px" }}
              ></td>
              <td
                className="p-1 text-gray-600 bg-gray-100"
                style={{ height: "26px" }}
              ></td>
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export default CrCashPayableOnShares;
